import {Type} from '@angular/core'
import {Tenant} from '../environments/env.type';

type TenantSlotConfig = {
  [K in Tenant]?: Promise<Type<any>>;
} & {
  '**': Promise<Type<any>>;
};

interface TenantComponentMap {
  [componentSlot: string]: TenantSlotConfig;
}

export const tenants: TenantComponentMap = {
  'header': {
    'milano': import('../app/welcome/header/milano/header/header.component').then(m => m.HeaderComponent),
    '**': import('../app/welcome/header/default/header/header.component').then(m => m.HeaderComponent)
  },
  'footer': {
    'milano': import('../app/welcome/category/category.component').then(m => m.CategoryComponent),
    '**': import('../app/welcome/promos/promos.component').then(m => m.PromosComponent)
  }
};
